import React from 'react';
import ReactPlayer from 'react-player'
import LineQueue from '../../utils/images/LineQuene.png';
import SeatBelt from '../../utils/images/SeatBelt.png';
import Cellphone from '../../utils/images/Cellphone.png';
import TrespassZebra from '../../utils/images/TrespassZebra.png';
import RedLight from '../../utils/images/RedLight.png';
import WrongTurn from '../../utils/images/WrongTurn.png';
import WrongWay from '../../utils/images/WrongWay.jpeg';
import SpeedLogo from '../../utils/images/Speed.png';
import { Speed } from '../../types'
import { buildMediaURL } from "../../actions/auth";

type Props = {
  id?: string
  imageSource: string,
  imageSourceSecond: string,
  ViolationType: string,
  violationImage: string,
  violationVideoUrl: string,
  videoSource: string,
  plateNumber: string,
  violationDate: string,
  carType: string,
  color: string,
  imagePopup?: (e: any) => void,
  showPopupImage?: boolean,
  PopupImageSource?: string,
  speedInfo: Speed,
};

export const ViolationListItemDetail = (props: Props) => (
  <div id={props.id}>
    <h5 className="historyheaderForDetails"> Event Detail</h5>
    {

      (props.ViolationType !== "seatbelt" && props.ViolationType !== "cellphone" && props.ViolationType !== "speed" && props.ViolationType !== "spotspeed") ?
        <div className="violationDetailsSection">
          <div className="violationDetailsSubSection">
            <div className="violationVideo" style={{ width: "45%", height: "250px" }}>
              <p className="violationVideoTitle">Event Video</p>
              <ReactPlayer id="violationDetailsSectionVideo"
                url={buildMediaURL(props.violationVideoUrl)}
                controls
                width='100%'
                height='100%'
              />
            </div>
            <div className="lprVideo" style={{ width: "45%", height: "250px" }}>
              <p className="lprVideoTitle">LPR Video</p>
              <ReactPlayer id="violationDetailsSectionVideo"
                url={buildMediaURL(props.imageSourceSecond.split(".")[0] + ".mp4")}
                controls
                width='100%'
                height='100%'
              />
            </div>
          </div>

          <div className="details">
            <span className="detailtitle">Time of Event  <span className="detailtValue"> {props.violationDate}</span></span>
            <span className="detailtitle">Plate Number <span className="detailtValue">{props.plateNumber}</span></span>
            {/*
                          <span className="detailtitle">Car Type <span className="detailtValue"> {props.carType}</span></span>
                          <span className="detailtitle">Color <span className="detailtValue"> {props.color} </span></span>
                          */}
            <span className="detailtitle">Event Type <span className="detailtValue">
              {renderSwitch(props.ViolationType)}
            </span></span>
          </div>
          <div className="violationDetailsImages">
            <h5 className="historyheader">Images</h5>
            {/* <img src={buildMediaURL(props.imageSource)} width ='200px' height='100px' onClick ={(e) => props.imagePopup && props.imagePopup(props.imageSource)}/>*/}
            <div className="cShotImage" style={{ width: '30%', height: '20%' }}>
              <p className="cShotImageTitle">C Shot</p>
              <img src={buildMediaURL(props.violationImage)} width='100%' height='100%' onClick={(e) => props.imagePopup && props.imagePopup(props.violationImage)} />
            </div>
            <div className="lprShotImage" style={{ width: '30%', height: '20%' }}>
              <p className="lprShotImageTitle">LPR Shot</p>
              <img src={buildMediaURL(props.imageSourceSecond)} width='100%' height='100%' onClick={(e) => props.imagePopup && props.imagePopup(props.imageSourceSecond)} />
            </div>
            <div className="aShotImage" style={{ width: '30%', height: '20%' }}>
              <p className="aShotImageTitle">A Shot</p>
              <img src={buildMediaURL(getAShotPath(props.violationImage))} width='100%' height='100%' onClick={(e) => props.imagePopup && props.imagePopup(getAShotPath(props.violationImage))} />
            </div>
            <div className="bShotImage" style={{ width: '30%', height: '20%' }}>
              <p className="bShotImageTitle">B Shot</p>
              <img src={buildMediaURL(getBShotPath(props.violationImage))} width='100%' height='100%' onClick={(e) => props.imagePopup && props.imagePopup(getBShotPath(props.violationImage))} />
            </div>
          </div>
        </div> : null
    }
    {
      (props.ViolationType === "seatbelt" || props.ViolationType === "cellphone") ?
        <div className="violationDetailsSection">
          <img src={buildMediaURL(props.violationImage)} width='100%' height='50%' onClick={(e) => props.imagePopup && props.imagePopup(props.violationImage)} />
          <div className="details">
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Time of Event <span className="detailtValue"> {props.violationDate}</span></span>
            {/*
                          <span className="detailtitle">Plate Number <span className="detailtValue">{props.plateNumber}</span></span>
                          <span className="detailtitle">Car Type <span className="detailtValue"> {props.carType}</span></span>
                          <span className="detailtitle">Color <span className="detailtValue"> {props.color} </span></span>
                          */}
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Plate Number <span className="detailtValue">{props.plateNumber}</span></span>
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Event Type <span className="detailtValue">
              {renderSwitch(props.ViolationType)}
            </span></span>
          </div>
          <div className="violationDetailsImages">
            <h5 className="historyheader">Images</h5>
            <div className="cShotImage" style={{ width: '30%', height: '20%' }}>
              <p className="cShotImageTitle" style={{ marginTop: '5%' }}>Enhanced Driver Shot</p>
              <img src={buildMediaURL(getSBMPEnhancedDriverCropPath(props.violationImage))} width='100%' height='100%' onClick={(e) => props.imagePopup && props.imagePopup(getSBMPEnhancedDriverCropPath(props.violationImage))} />
            </div>
          </div>
        </div> : null
    }
    {
      props.ViolationType === "speed" ?
        <div className="violationDetailsSection">
          <div className="violationDetailsSubSection">
            <div className="entryImageSection" style={{ width: "45%" }}>
              <p className="entryTitle">Entry</p>
              <img id="entryImage"
                src={buildMediaURL(getALPRShotPath(props.violationImage))}
                width='100%'
                height='100%'
                onClick={(e) => props.imagePopup && props.imagePopup(getALPRShotPath(props.violationImage))}
              />
              <p className="entryTitle">Camera: {`${props.speedInfo.avgSpeed.entry.id}`}</p>
              <p className="entryTitle">Time: {`${props.speedInfo.avgSpeed.entry.time}`}</p>
            </div>

            <div className="exitImageSection" style={{ width: "45%" }}>
              <p className="exitTitle">Exit</p>
              <img id="exitImage"
                src={buildMediaURL(props.violationImage)}
                width='100%'
                height='100%'
                onClick={(e) => props.imagePopup && props.imagePopup(props.violationImage)}
              />
              <p className="entryTitle">Camera: {`${props.speedInfo.avgSpeed.exit.id}`}</p>
              <p className="entryTitle">Time: {`${props.speedInfo.avgSpeed.exit.time}`}</p>
            </div>
          </div>
          <div className="details">
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Time of Event <span className="detailtValue"> {props.violationDate}</span></span>
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Plate Number <span className="detailtValue">{props.plateNumber}</span></span>
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Distance  <span className="detailtValue">{`${props.speedInfo.avgSpeed.distance} metres`}</span></span>
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Time Difference <span className="detailtValue">{`${props.speedInfo.avgSpeed.ts_diff} sec`}</span></span>
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Average Speed <span className="detailtValue">{`${props.speedInfo.avgSpeed.value} ${props.speedInfo.avgSpeed.unit} (${Math.round((props.speedInfo.avgSpeed.value/1.609)*1000)/1000} MPH)`}</span></span>
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Event Type <span className="detailtValue">
              {renderSwitch(props.ViolationType)}
            </span></span>
          </div>
        </div> : null
    } {
      props.ViolationType === "spotspeed" ?
        <div className="violationDetailsSection">
          <div className="violationDetailsSubSection">
            <div className="entryImageSection" style={{ width: "45%" }}>
              <p className="entryTitle">Entry</p>
              <img id="entryImage"
                src={buildMediaURL(getAShotPath(props.violationImage))}
                width='100%'
                height='100%'
                onClick={(e) => props.imagePopup && props.imagePopup(getAShotPath(props.violationImage))}
              />
              <p className="entryTitle">Camera: {`${props.speedInfo.spotSpeed.id}`}</p>
              <p className="entryTitle">Time: {`${props.speedInfo.spotSpeed.entry.time}`}</p>
            </div>

            <div className="exitImageSection" style={{ width: "45%" }}>
              <p className="exitTitle">Exit</p>
              <img id="exitImage"
                src={buildMediaURL(props.violationImage)}
                width='100%'
                height='100%'
                onClick={(e) => props.imagePopup && props.imagePopup(props.violationImage)}
              />
              <p className="entryTitle">Camera: {`${props.speedInfo.spotSpeed.id}`}</p>
              <p className="entryTitle">Time: {`${props.speedInfo.spotSpeed.exit.time}`}</p>
            </div>
          </div>
          <div className="details">
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Time of Event <span className="detailtValue"> {props.violationDate}</span></span>
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Plate Number <span className="detailtValue">{props.plateNumber}</span></span>
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Speed <span className="detailtValue">{`${props.speedInfo.spotSpeed.value} ${props.speedInfo.spotSpeed.unit} (${Math.round((props.speedInfo.spotSpeed.value/1.609)*1000)/1000} MPH)`}</span></span>
            <span className="detailtitle" style={{ fontWeight: "bold" }}>Event Type <span className="detailtValue">
              {renderSwitch(props.ViolationType)}
            </span></span>
          </div>
        </div> : null
    }

    {props.showPopupImage ?
      <div className="PopupImage" onLoad={(e) => magnify("PopupImage", 3)}>
        <img id="PopupImage" src={buildMediaURL(props.PopupImageSource || props.violationImage)} width='100%' height='100%' />
        <div id="img-magnifier-glass" className="img-magnifier-glass"></div>
        <button id="crossButton" onClick={(e) => { props.imagePopup && props.imagePopup(props.id) }}>X</button>
      </div>
      : null
    }

  </div>
)

const getAShotPath = (cShot: string) => {
  let tmp: string[] = cShot.split("/");
  let last_ele: string = tmp.pop()!;
  let extension: string = last_ele.split('.')[1];
  let aShotPath = tmp.join('/') + '/a_shot' + '.' + extension;
  return aShotPath;
}

const getALPRShotPath = (cShot: string) => {
  let tmp: string[] = cShot.split("/");
  let last_ele: string = tmp.pop()!;
  let extension: string = last_ele.split('.')[1];
  let aShotPath = tmp.join('/') + '/ALPR_1' + '.' + extension;
  return aShotPath;
}

const getBShotPath = (cShot: string) => {
  let tmp: string[] = cShot.split("/");
  let last_ele: string = tmp.pop()!;
  let extension: string = last_ele.split('.')[1];
  let bShotPath = tmp.join('/') + '/b_shot' + '.' + extension;
  return bShotPath;
}

const getSBMPEnhancedDriverCropPath = (cShot: string) => {
  let tmp: string[] = cShot.split("/");
  let last_ele: string = tmp.pop()!;
  let extension: string = last_ele.split('.')[1];
  let name: string = last_ele.split('.')[0];
  let shotPath = tmp.join('/') + '/' + name + '_crop_enhanced' + '.' + extension;
  return shotPath;
}

const renderSwitch = (param: string) => {

  switch (param) {
    case 'cutlane':
      return (
        <span>
          Queue Jumping
          <img src={LineQueue} id="" />
        </span>
      );
    case 'runningredlight':
      return (
        <span>
          Red Light
          <img src={RedLight} id="" />
        </span>
      );
    case 'trespass_zebra':
      return (
        <span>
          Trespass Zebra
          <img src={TrespassZebra} id="" />
        </span>
      );
    case 'wrongturn':
      return (
        <span>
          Wrong Turn
          <img src={WrongTurn} id="" />
        </span>
      );
    case 'seatbelt':
      return (
        <span>
          SeatBelt
          <img src={SeatBelt} id="" />
        </span>
      );
    case 'cellphone':
      return (
        <span>
          Cellphone
          <img src={Cellphone} id="" />
        </span>
      );
    case 'wrongway':
      return (
        <span>
          Wrong Way
          <img src={WrongWay} id="" />
        </span>
      );
    case 'speed':
      return (
        <span>
          Avg. Speed
          <img src={SpeedLogo} id="" />
        </span>
      );
    case 'spotspeed':
      return (
        <span>
          Spot Speed
          <img src={SpeedLogo} id="" />
        </span>
      );
    default:
      return 'others';
  }
}
const magnify = (imgID: string, zoom: number) => {
  let img: HTMLImageElement;
  let glass: HTMLElement;
  img = document.getElementById(imgID) as HTMLImageElement;
  glass = document.getElementById("img-magnifier-glass") as HTMLElement;
  /*set background properties for the magnifier glass:*/
  glass.style.backgroundImage = "url('" + img.src + "')";
  glass.style.backgroundRepeat = "no-repeat";
  glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";
  let bw: number = 3;
  let w: number = glass.offsetWidth / 2;
  let h: number = glass.offsetHeight / 2;
  /*execute a function when someone moves the magnifier glass over the image:*/
  glass.addEventListener("mousemove", moveMagnifier);
  img.addEventListener("mousemove", moveMagnifier);
  /*and also for touch screens:*/
  glass.addEventListener("touchmove", moveMagnifier);
  img.addEventListener("touchmove", moveMagnifier);
  function moveMagnifier(e: any) {
    var pos;
    let x: number, y: number;
    /*prevent any other actions that may occur when moving over the image*/
    e.preventDefault();
    /*get the cursor's x and y positions:*/
    pos = getCursorPos(e);
    x = pos.x;
    y = pos.y;
    /*prevent the magnifier glass from being positioned outside the image:*/
    if (x > img.width - (w / zoom)) {
      x = img.width - (w / zoom);
    }
    if (x < w / zoom) { x = w / zoom; }
    if (y > img.height - (h / zoom)) { y = img.height - (h / zoom); }
    if (y < h / zoom) { y = h / zoom; }

    /*set the position of the magnifier glass:*/
    glass.style.left = (x - w) + "px";
    glass.style.top = (y - h) + "px";
    /*display what the magnifier glass "sees":*/
    glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
  }
  function getCursorPos(e: any) {
    var a, x = 0, y = 0;
    e = e || window.event;
    /*get the x and y positions of the image:*/
    a = img.getBoundingClientRect();
    /*calculate the cursor's x and y coordinates, relative to the image:*/
    x = e.pageX - a.left;
    y = e.pageY - a.top;
    /*consider any page scrolling:*/
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return { x: x, y: y };
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/ViolationListItemDetail.tsx